<template>
	<div class="individual-stat">
		<p class="stat-number">{{ statNumber }}</p>
		<p class="stat-subhead">{{ statSubhead }}</p>
	</div>
</template>

<script>

export default {
	name: 'IndividualStat',
	components: {
	},
	props: {
		statNumber: String,
		statSubhead: String,
	},
};
</script>

<style scoped lang="scss">
.individual-stat {
	padding:30px;
	.stat-number {
		font-size:30px;
		font-weight: 800;
		color: $primary-color;
	}
}
</style>
